import * as i18n			from "@geotoura/shared/i18n";

import { messages as de } from "@geotoura/common/locale_de";
import { messages as en } from "@geotoura/common/locale_en";
import { messages as it } from "@geotoura/common/locale_it";

export type Messages = Readonly<typeof de>;
export namespace Messages {
	export const of:i18n.Localized<Messages>	= { de, en, it };
}
